import styled from 'styled-components'

export const AktivWrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap');
  font-family: 'Roboto', sans-serif;
  color: #333333;
  max-width: 700px;
  width: 100%;
`

export const Content = styled.main`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Heading = styled.h1`
  font-weight: 700;
  font-size: 16px;
  color: #4c4947;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 400px;
`

export const MapLink = styled.a.attrs(() => ({
  target: '_blank',
  rel: 'noopener',
}))`
  border: 0;
`
